module.exports = __webpack_public_path__ + "img/R8803-IL.5a891fe2.jpg";